import React from "react";
import CommonModal from "../../common/commonmodal/CommonModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { primaryColor, secondaryColor } from "../../../utils/comon";

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center p-4">
        {/* Logout Icon Circle */}
        <div 
          className="w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-sm border border-white dark:border-bordercolor"
          style={{ backgroundColor: "var(--color-secondaryaccent)", color: "var(--color-primaryaccent)" }}
        >
          <FontAwesomeIcon icon={faRightFromBracket} className="text-xl" />
        </div>

        {/* Content */}
        <h2 className="text-xl font-bold text-[#0F172A] dark:text-textprimary mb-3">Confirm Logout</h2>
        <p className="text-sm text-[#64748B] dark:text-textsecondary leading-relaxed mb-8 max-w-[280px]">
          Are you sure you want to logout? You will need to re-authenticate to access your tenants.
        </p>

        {/* Actions */}
        <div className="flex gap-4 w-full">
          <button 
            onClick={onClose}
            className="flex-1 py-2.5 border border-gray-200 dark:border-bordercolor rounded-xl text-sm font-bold text-[#475569] dark:text-textsecondary hover:bg-gray-50 dark:hover:bg-actionitembg transition-colors shadow-sm"
          >
            Cancel
          </button>
          <button 
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white shadow-sm hover:opacity-90 transition-opacity"
            style={{ backgroundColor: "var(--color-primaryaccent)" }}
          >
            Logout
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

export default LogoutModal;
